import React, { useState } from 'react'
import { Container, Navbar, Nav } from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from '../assets/logo.png'
import { useLocation, useNavigate } from 'react-router-dom';

const NavbarComponent = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = () => setExpanded(!expanded);
  const handleClose = () => setExpanded(false);

  const handleNavClick = (sectionId) => {
    handleClose(); // close navbar

    if (location.pathname === '/') {
      // Already on homepage — scroll directly
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Not on homepage — navigate to home + hash
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <Navbar expand="lg" variant='dark' className="navbar py-3" expanded={expanded}>
      <Container fluid>
        {/* Logo */}
        <Navbar.Brand href="/">
          <img
            src={logo}
            width="180"
            height="auto"
            className="d-inline-block align-top"
            alt="Hotel Logo"
          />
        </Navbar.Brand>

        {/* Hamburger menu */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />

        <Navbar.Collapse id="basic-navbar-nav">
          {/* Center - Nav Links */}
          <Nav className="mx-auto">
            <Nav.Link as="button" className="mx-2 navlink btn btn-link text-white" onClick={() => handleNavClick('home')}>HOME</Nav.Link>
            <Nav.Link as="button" className="mx-2 navlink btn btn-link text-white" onClick={() => handleNavClick('about')}>ABOUT US</Nav.Link>
            <Nav.Link className="mx-2 navlink btn btn-link text-white" href="/room" onClick={handleClose}>ROOMS</Nav.Link>
            <Nav.Link as="button" className="mx-2 navlink btn btn-link text-white" onClick={() => handleNavClick('amenties')}>AMENITIES</Nav.Link>
            <Nav.Link as="button" className="mx-2 navlink btn btn-link text-white" onClick={() => handleNavClick('contact')}>CONTACT US</Nav.Link>
            <Nav.Link className="mx-2 navlink btn btn-link text-white border ps-3 pe-3 pt-2 pb-2 rounded-3 mx-auto" style={{width: 'fit-content',boxShadow: '2px 2px 5px 2px rgba(255, 255, 255, 0.5)'}} href="https://www.secure-booking-engine.com/accounts/yJFnF0Rt-psOOiSt7AikzA/properties/qLHRcr_YnIrioFqiOtvf4A/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/vD4UXXAqiAsm384soqO4Ig/#!/rooms'" target='_blank' onClick={handleClose}>Book Now</Nav.Link>
          </Nav>

          {/* Right - Mail and Address */}
          <div className="text-end d-none d-lg-block">
            <div style={{ fontSize: '0.9rem', fontWeight: '500' }}>
              <a href="mailto:elkars@elkarshomestay.com" className="text-decoration-none text-white">
                elkars@elkarshomestay.com
              </a>
              <i className="ms-2 fas fa-envelope"></i>
            </div>
            <div style={{ fontSize: '0.8rem' }}>
              <a href="tel:+917299537537" className="text-decoration-none text-white">
                +91 7299537537
              </a>
              <i className="ms-2 fas fa-phone"></i>
            </div>
            <div style={{ fontSize: '0.8rem' }}>
              <a
                href="https://maps.app.goo.gl/eASx7S99P6sjnqtL6"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-white"
              >
                Attuvampatti, kodaikanal
              </a>
              <i className="ms-2 fas fa-map-marker-alt"></i>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavbarComponent;
